import { normalizeBulkLaterality } from "./bulkUploadProjection";

const invalidResponse = () => new Error("Invalid View Images response");
const nonemptyString = (value) =>
  typeof value === "string" && value.trim().length > 0;

const legacyLateralityFromFilename = (laterality, name) => {
  if (
    typeof laterality !== "string" ||
    laterality.trim().toLowerCase() !== "unknown" ||
    !nonemptyString(name)
  ) {
    return "";
  }
  const eyeTokens = name
    .trim()
    .toUpperCase()
    .split(/[_ .-]+/)
    .filter((token) => token === "OD" || token === "OS");
  if (eyeTokens.length !== 1) return "";
  return eyeTokens[0] === "OD" ? "right" : "left";
};

export const normalizeViewImagesResponse = (response) => {
  const responseData = response?.data;
  const imagesWithLinks = Array.isArray(responseData)
    ? responseData
    : responseData?.imagesWithLinks;
  if (!Array.isArray(imagesWithLinks)) {
    throw invalidResponse();
  }

  const rowsByGuid = new Map();
  for (const remote of imagesWithLinks) {
    const data = remote?.data;
    const guid = typeof data?.guid === "string" ? data.guid.trim() : "";
    const laterality =
      normalizeBulkLaterality(data?.laterality) ||
      legacyLateralityFromFilename(data?.laterality, data?.name);
    const model = data?.model || data?.Model;
    const orgId = Number(data?.orgz_id);
    if (
      !guid ||
      data?.mrn !== null ||
      !Number.isSafeInteger(orgId) ||
      orgId < 1 ||
      !laterality ||
      !nonemptyString(model) ||
      !nonemptyString(data?.status) ||
      !nonemptyString(remote?.url)
    ) {
      throw invalidResponse();
    }

    const status = {
      guid,
      Model: model.trim(),
      laterality,
      status: data.status,
      lmodon: data.lmodon,
      review: data.review,
    };
    const existing = rowsByGuid.get(guid);
    if (existing) {
      const duplicate = existing.status.some(
        (item) =>
          item.Model.toLowerCase() === status.Model.toLowerCase() &&
          item.laterality === status.laterality
      );
      if (
        duplicate ||
        existing.orgz_id !== orgId ||
        existing.laterality !== laterality ||
        existing.url !== remote.url
      ) {
        throw invalidResponse();
      }
      existing.status.push(status);
      continue;
    }

    rowsByGuid.set(guid, {
      consent: data.dr_status || "",
      confidenceValues: data.confidenceValues,
      guid,
      imodon: data.lmodon,
      info: {
        orignalName: data.name,
        guid,
        relPath: data.img_folder,
      },
      laterality,
      mrn: null,
      orgz_id: orgId,
      quality: data.quality,
      drConsentDetails: {
        doc_cf: data.doc_cf,
        doc_diff_dis: data.doc_diff_dis,
        doc_dis: data.doc_dis,
        doc_dis_catg: data.doc_dis_catg,
        doc_ref: data.doc_ref,
        doc_rec: data.doc_rec || "",
        doc_sec_fin: data.doc_sec_fin,
      },
      status: [status],
      url: remote.url,
    });
  }

  const rows = Array.from(rowsByGuid.values());
  const countValue = Array.isArray(responseData) ? rows.length : responseData.count;
  const count = Number(countValue);
  if (!Number.isSafeInteger(count) || count < rows.length) {
    throw invalidResponse();
  }
  return { rows, count };
};
